<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :loading="$apollo.queries.items.loading"
    :search-input.sync="search"
    :placeholder="placeholder"
    :item-value="itemValue"
    item-text="memberNumber"
    prepend-icon="search"
    clearable
    hide-no-data
    no-filter
    v-bind="$attrs"
    @input="onInput"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item.memberName || data.item.businessName || data.item.tradingName || data.item.entityName }}</v-list-item-title>
        <v-list-item-subtitle>{{ data.item.memberNumber }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
  </v-autocomplete>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'RegistrationSearchField',

  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    itemValue: {
      type: String,
      default: '_id'
    },
    filter: {
      type: Object
    }
  },

  data: () => ({
    items: [],
    search: ''
  }),

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    onInput (event) {
      this.$emit('input', event)
    }
  },

  apollo: {
    items: {
      query: gql`query SearchMembers($search: FilterSearchManyPublicRegistrationInput! $filter: FilterFindManyPublicRegistrationInput) {
        items: publicRegistrationSearchMany(search: $search, filter: $filter) {
          _id
          abn
          memberNumber
          memberName
          businessName
          tradingName
          entityName
        }
      }`,
      variables () {
        return {
          search: {
            [this.itemValue]: this.value,
            abn: this.search,
            memberNumber: this.search,
            memberName: this.search,
            entityName: this.search,
            tradingName: this.search,
            businessName: this.search
          },
          filter: this.filter
        }
      },
      error (e) { this.onError(e) },
      debounce: 250
    }
  }
}
</script>
